import Macy from 'macy';
import Debounce from '../Utils/Debounce';

const macyContainers = Array.from(document.querySelectorAll('.macy-container-js'));

macyContainers.forEach(el => {
	var elementId = el.getAttribute('id');

	Macy({
		container: '#' + elementId,
		trueOrder: true,
		margin: 40,
		columns: 3,
		breakAt: {
			1240: {
				margin: 30,
			},
			960: {
				columns: 2,
			},
			768: {
				margin: 20,
			},
			600: {
				columns: 1,
				margin: 0,
			},
		},
	});
});

// Add centering of card elements if screensize is mobile
macyContainers.forEach(elem => {
	if (window.innerWidth <= 600) {
		elem.childNodes.forEach(child => child.classList.add('partner-cards__card-center'));
	}
});

// Add or remove centering of card elements on resize
const repositionMacyContainers = () => {
	macyContainers.forEach(elem => {
		if (window.innerWidth <= 600) {
			elem.childNodes.forEach(child => child.classList.add('partner-cards__card-center'));
		} else {
			elem.childNodes.forEach(child => child.classList.remove('partner-cards__card-center'));
		}
	});
};

window.addEventListener('resize', Debounce(repositionMacyContainers, 250));
